import { createFileRoute } from "@tanstack/react-router";
import EventsPage from "@project/user/pages/community/events";

export const Route = createFileRoute("/_user/_community/events")({
  head: () => ({
    meta: [
      { title: "Donation Events — Jivandhara Old Age Home" },
      {
        name: "description",
        content:
          "Upcoming Jain dharma events, daan abhiyans and community programs at Jivandhara. Donate online for donation events.",
      },
    ],
  }),
  component: EventsPage,
});
